<template>
<v-container>
    <h1>About</h1>
</v-container>
</template>

<script>

  export default {
    name: 'About',

  }
</script>
